// extracted by mini-css-extract-plugin
export var container = "_cp-0";
export var infoIcon = "_cp-2";
export var titleRowCol = "_cp-1";